import { Button, Modal } from "react-bootstrap";
import React, {useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'

import NsModalHeader from "../../../components/modal/NsModalHeader";
import Translate from "../../../components/Translate";
import NsDatePicker from "../../../components/NsDatePicker";
import { convertiDateInDataPerDb } from "../../../utility/common";
import {updateDocumentoApi} from "../services/ArchivioServices";


export default function ModalUpdateDocumentoArchivio({
                                                   documento,
                                                   show,
                                                   handleClose,
                                                   submitOk,
                                               }) {

    const [titoloDoc, setTitoloDoc] = useState('');
    const [tipo, setTipo] = useState('');
    const [soggetto, setSoggetto] = useState('');
    const [formato, setFormato] = useState('');
    const [dataDoc, setDataDoc] = useState(null);
    const [annoDoc, setAnnoDoc] = useState('');
    const [annoCirca, setAnnoCirca] = useState(false);
    const [note, setNote] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    // Reset completo allo stato iniziale
    const resetState = () => {
        setTitoloDoc('');
        setTipo('');
        setSoggetto('');
        setFormato('');
        setAnnoDoc('');
        setAnnoCirca(false);
        setNote('');
        setDataDoc(null);
        setIsSaving(false);
    };

    const handleSave = async () => {
        if (!titoloDoc) {
            alert("Il campo Titolo è obbligatorio.");
            return;
        }

        setIsSaving(true);

        const values = {
            'titolo': titoloDoc,
            'tipo': tipo,
            'soggetto': soggetto,
            'formato': formato,
            'anno_doc': annoDoc,
            'anno_circa': annoCirca,
            'data_doc': dataDoc ? convertiDateInDataPerDb(dataDoc) : '',
            'note': note,
        }

        try {
            await updateDocumentoApi(documento.id_archivio_documento, values);

            submitOk();
            handleClose();
        } catch (error) {
            alert("Errore durante la modifica del documento. Riprova.");
        }
    };

    async function initDocumento() {
        setTitoloDoc(documento.titolo);
        setTipo(documento.tipo);
        setSoggetto(documento.soggetto);
        setFormato(documento.formato);
        setNote(documento.note);
        setDataDoc(documento.data_doc);
        setAnnoDoc(documento.anno_doc);
        setAnnoCirca(parseInt(documento.anno_circa) === 1);
    }

    useEffect(() => {
        resetState();
        if (documento) {
            initDocumento();
        }
    }, [documento]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <NsModalHeader title={`Modifica documento ${documento && documento.titolo}`} />
            <Modal.Body>
                <div className={"row g-3"}>
                    <div className={"col-md-6"}>
                        <label htmlFor="titolo" className="form-label">Titolo*:</label>
                        <input
                            type={"text"}
                            id={"titolo"}
                            name={"titolo"}
                            className={"form-control"}
                            value={titoloDoc}
                            onChange={(ev) => setTitoloDoc(ev.target.value)}
                            required
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="soggetto" className="form-label">Soggetto proprietario:</label>
                        <input
                            type={"text"}
                            id={"soggetto"}
                            name={"soggetto"}
                            className={"form-control"}
                            value={soggetto}
                            onChange={(ev) => setSoggetto(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="formato" className="form-label">Formato e caratteristiche materiali:</label>
                        <input
                            type={"text"}
                            id={"formato"}
                            name={"formato"}
                            className={"form-control"}
                            value={formato}
                            onChange={(ev) => setFormato(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="dataDoc" className="form-label">Data documento:</label>
                        <NsDatePicker
                            nome={"dataDoc"}
                            dataSelezionata={dataDoc}
                            setSelectedDate={(date) => setDataDoc(date)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="formato" className="form-label">Anno documento (in sostituzione alla Data documento):</label>
                        <input
                            type={"number"}
                            id={"annoDoc"}
                            name={"annoDoc"}
                            className={"form-control"}
                            value={annoDoc}
                            onChange={(ev) => setAnnoDoc(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6 form-check"}>
                        <input
                            type={"checkbox"}
                            id={"annoCirca"}
                            name={"annoCirca"}
                            className={"form-check-input ns-form-check-bg"}
                            checked={annoCirca}
                            onChange={(ev) => setAnnoCirca(ev.target.checked)}
                        />
                        <label htmlFor="annoCirca" className="form-check-label">Anno circa (ca.):</label>
                    </div>
                    <div className={"col-md-12"}>
                        <label htmlFor="note" className="form-label">Note:</label>
                        <textarea
                            id={"note"}
                            name={"note"}
                            className={"form-control"}
                            rows={3}
                            value={note}
                            onChange={(ev) => setNote(ev.target.value)}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={isSaving}>
                    <Translate>Chiudi</Translate>
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={!titoloDoc}>
                    {isSaving ? 'Salvataggio...' : <Translate>Salva</Translate>}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}